"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSOService = void 0;
var tslib_1 = require("tslib");
var auth0_spa_js_1 = require("@auth0/auth0-spa-js");
var mobx_1 = require("mobx");
var notification_service_1 = require("../components/notification.toast/notification.service");
var i18n_1 = require("../i18n");
var index_1 = require("./index");
var SSOService = /** @class */ (function () {
    function SSOService() {
        this.__priority = 24;
        this.inFlight = true;
    }
    SSOService.prototype.setUser = function (user) {
        this.user = user;
    };
    SSOService.prototype.setToken = function (token) {
        this.token = token;
    };
    Object.defineProperty(SSOService.prototype, "isAuthenticated", {
        get: function () {
            return Boolean(this.user);
        },
        enumerable: false,
        configurable: true
    });
    SSOService.prototype.init = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var clientId, domain, token, user, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clientId = index_1.Services.Config.config.get('auth0.client.id');
                        domain = index_1.Services.Config.config.get('auth0.domain');
                        if (!(clientId && domain)) return [3 /*break*/, 6];
                        this.client = new auth0_spa_js_1.Auth0Client({
                            client_id: clientId,
                            domain: domain,
                            redirect_uri: window.location.origin,
                            audience: "".concat(window.location.origin, "/v1/")
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.client.getTokenSilently()];
                    case 2:
                        token = _a.sent();
                        return [4 /*yield*/, this.client.getUser()];
                    case 3:
                        user = _a.sent();
                        index_1.Services.Log.Logger.info('Signed in with Auth0', token);
                        this.setToken(token);
                        this.setUser(user);
                        this.inFlight = false;
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        if ((error_1 === null || error_1 === void 0 ? void 0 : error_1.message) !== 'Login required') {
                            index_1.Services.Log.Logger.error('Auth0 error', error_1);
                            if (error_1.message) {
                                notification_service_1.NotificationService.errorAsString(error_1.message);
                            }
                            else {
                                notification_service_1.NotificationService.error({ key: i18n_1.T.ERROR_GENERAL });
                            }
                        }
                        this.inFlight = false;
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        index_1.Services.Log.Logger.warn('Unable to start SSO Service: missing client ID or domain variable');
                        notification_service_1.NotificationService.warn({ key: i18n_1.T.UNABLE_TO_START_SSO_SERVICE });
                        this.inFlight = false;
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Trigger a login attempt
     * @param options Extra preferences for the login function using {@link RedirectLoginOptions}
     */
    SSOService.prototype.login = function () {
        return tslib_1.__awaiter(this, arguments, void 0, function (options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.client) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.client.loginWithRedirect(options)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Logs the user out
     * @param federated Logs the user out of their IDP so they will have to full log back in again to access
     * @refer https://auth0.com/docs/authenticate/login/logout/log-users-out-of-idps
     */
    SSOService.prototype.logout = function () {
        return tslib_1.__awaiter(this, arguments, void 0, function (federated) {
            if (federated === void 0) { federated = false; }
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.client) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.client.logout({ federated: federated })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    SSOService.prototype.resetPassword = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, index_1.Services.Rest.rest.SSOUser.triggerResetPassword({ email: this.user.email })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], SSOService.prototype, "inFlight", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SSOService.prototype, "user", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SSOService.prototype, "token", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], SSOService.prototype, "setUser", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SSOService.prototype, "setToken", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], SSOService.prototype, "isAuthenticated", null);
    return SSOService;
}());
exports.SSOService = SSOService;
//# sourceMappingURL=sso.service.js.map